export default __webpack_public_path__ + "static/media/LoadingScreenMuru.74dd0444.png";